import { ReactNode } from "react";
import {
  DollarOutlined,
  StarOutlined,
  RetweetOutlined,
} from "@ant-design/icons";
import { ReactComponent as OutlinedArrowRighTop } from "../../../../images/icons/OutlinedArrowRighTop.svg";

type TPaymentIcon = {
  value: string;
  icon: ReactNode;
};

const PAYMENT_ICONS: TPaymentIcon[] = [
  {
    value: "ImpoundDistribution",
    icon: <span className="mt-0">{<OutlinedArrowRighTop />}</span>,
  },
  {
    value: "Disbursement",
    icon: <span className="mt-0">{<OutlinedArrowRighTop />}</span>,
  },
  {
    value: "Fees",
    icon: <span className="mt-0">{<OutlinedArrowRighTop />}</span>,
  },
  {
    value: "RegularPayment",
    icon: <RetweetOutlined className="text" />,
  },
  {
    value: "OneTimePayment",
    icon: <DollarOutlined className="text" />,
  },
  {
    value: "PayoffPayment",
    icon: <StarOutlined className="text" />,
  },
];

export const useGetIcon = () => {
  const getIcon = (type: string) => {
    const icon = PAYMENT_ICONS.find((icon) => icon.value === type)?.icon;

    return icon ? icon : "";
  };
  return { getIcon };
};
